import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AnalyticsDashboard from "../DataHistory/AnalyticsDashboard";
// import tutorialVideo from '../../assets/videos/tutorial.mp4';
// import TutorialVideo from "./TutorialVideo";

const WelcomeDashboard = () => {
  const navigate = useNavigate();
  const applyResponse = useSelector((s) => s.file?.applyResponse);

  const handleGetStarted = () => {
    navigate("/dashboard/data-entry");
  };

  const handleLearnMore = () => {
    // console.log("Learn More");
    // Implement learn more functionality
  };

  const hasResults = !!applyResponse?.blob_download_link;


  return (
    <div className="min-h-[100dvh] w-full flex items-start p-6 md:p-12 relative z-20">
      <div className="container mx-auto w-full">
        {hasResults ? (
          <AnalyticsDashboard applyResponse={applyResponse} />
        ) : (
          <div className="flex flex-col md:flex-row gap-8 w-full">
            <LeftPanel
              onGetStarted={handleGetStarted}
              onLearnMore={handleLearnMore}
            />
            <RightPanel />
          </div>
        )}
      </div>
    </div>
  );
};

const LeftPanel = ({ onGetStarted, onLearnMore }) => (
  <div className="w-full md:w-7/12">
    <div className="bg-[#141c31] rounded-2xl p-8 md:p-10 shadow-lg">
      <WelcomeSection />
      <ActionButtons onGetStarted={onGetStarted} onLearnMore={onLearnMore} />
    </div>
  </div>
);

const WelcomeSection = () => (
  <>
    <div className="mb-6">
      <div className="text-base text-blue-500 font-medium mb-2">
        Welcome back!
      </div>
      <h1 className="leading-tight font-serif">
        <span className="block text-4xl md:text-5xl font-extrabold text-white">
          Your analytics
        </span>
        <span className="block text-4xl md:text-5xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-indigo-500">
          dashboard
        </span>
      </h1>
    </div>
    <p className="text-slate-200 max-w-xl mb-6 text-base">
      Analytics and reports will be displayed here. Get insights from
      your data with powerful visualizations and intelligent analysis.
    </p>
  </>
);

const ActionButtons = ({ onGetStarted, onLearnMore }) => (
  <div className="flex flex-wrap gap-6 mb-8">
    <button
      onClick={onGetStarted}
      className="px-6 py-2 rounded-full font-medium shadow-md bg-gradient-to-r from-indigo-500 to-blue-500 text-white hover:from-indigo-600 hover:to-blue-600 transition"
    >
      Get Started
    </button>
    <button
      onClick={onLearnMore}
      className="px-5 py-2 rounded-full font-medium border bg-white text-slate-800 hover:bg-slate-50 transition"
    >
      Learn More
    </button>
  </div>
);


const RightPanel = () => (
  <div className="w-full md:w-5/12">
    <div className="rounded-2xl p-6 shadow-xl bg-[#141c31] ">
      <h3 className="text-2xl font-semibold text-white text-center mb-1 font-sans">
        How to use Analytics dashboard
      </h3>
      <p className="text-base text-center text-slate-200 mb-6">
        Watch this quick tutorial to get started
      </p>
      {/* <TutorialVideo videoSrc={tutorialVideo} /> */}
    </div>
  </div>
);

export default WelcomeDashboard;
